import React, { useRef, useState } from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const Container = styled.div`
  border-radius: 3px;
  background-color: ${(props) =>
    props.$backgroundColor ?? props.theme?.whiteSmoke};
  padding: 3px 8px;
  display: inline-block;
  max-width: 100%;
`;

const StyledText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.$textColor ?? props.theme?.mortar};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const renderTooltip = (text, props) => {
  const { ...other } = props;
  return (
    <Tooltip id="button-tooltip" {...other}>
      {text}
    </Tooltip>
  );
};

const CustomChip = (props) => {
  const { text, backgroundColor, textColor, onClick, tooltipPlacement } = props;

  const [isTooltipEnabled, setIsTooltipEnabled] = useState(false);

  const containerRef = useRef();

  const showTooltip = () => {
    if (containerRef) {
      const clientWidth = containerRef.current.clientWidth;
      const scrollWidth = containerRef.current.scrollWidth;

      if (scrollWidth > clientWidth) {
        setIsTooltipEnabled(true);
      }
    }
  };

  const hideTooltip = () => {
    if (isTooltipEnabled) {
      setIsTooltipEnabled(false);
    }
  };

  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={(tooltipProps) => renderTooltip(text, tooltipProps)}
      show={isTooltipEnabled}
    >
      <Container
        data-testid={props["data-testid"] || "custom-chip"}
        $backgroundColor={backgroundColor}
        onClick={onClick}
        onMouseEnter={() => showTooltip()}
        onMouseLeave={() => hideTooltip()}
        onTouchStart={() => showTooltip()}
        onTouchEnd={() => hideTooltip()}
      >
        <StyledText $textColor={textColor} ref={containerRef}>
          {text}
        </StyledText>
      </Container>
    </OverlayTrigger>
  );
};

CustomChip.defaultProps = {
  tooltipPlacement: "top",
  text: null,
  backgroundColor: null,
  textColor: null,
  onClick: null,
};

CustomChip.propTypes = {
  tooltipPlacement: PropTypes.string,
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  onClick: PropTypes.func,
};

export default withTheme(CustomChip);
